import {
  Component,
  OnInit,
  ElementRef,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { GameService } from "../../services/game.service";
import { AudioPlayerService } from "../../services/audio-player.service";
import { environment } from "../../../environments/environment";

const captions = {NL: 'Plakboek', EN: 'Scrapbook'};
const styles = {
  NL: {fontSize: '21.058849334716797px', fontSizeHover: '20.637670516967773px'},
  EN: {fontSize: '18px', fontSizeHover: '18px'},
}

@Component({
  selector: "app-img-roadmap",
  templateUrl: "./img-roadmap.component.html",
  styleUrls: ["./img-roadmap.component.less"],
})
export class ImgRoadmapComponent implements OnInit, OnDestroy {
  @Output() onLevelClick = new EventEmitter<any>();
  @Output() onLevelSelectClick = new EventEmitter<any>();
  private hideElements = ["textbox"];
  private version: "jijenik" | "broedels" = "broedels";
  scrapbookCaption = captions[environment.language];
  // scrapbookCaptionSize = '21.058849334716797';
  scrapbookCaptionStyle = {
    fontSize: styles[environment.language].fontSize,
    fill:'#182036',
    fontFamily:'AbrilFatface-Regular, Abril Fatface'
  };
  scrapbookCaptionHoverStyle = {
    // fontSize:'20.637670516967773',
    fontSize: styles[environment.language].fontSizeHover,
    fill:'#182036',
    fontFamily:'AbrilFatface-Regular, Abril Fatface'
  };

  private states = ["active", "done"];
  private levels = [
    "start",
    "lvl0",
    "lvl1",
    "lvl2",
    "lvl3",
    "lvl4",
    "lvl5",
    "lvl6",
    "lvl7",
    "lvl8",
  ];

  constructor(
    private gameService: GameService,
    private elRef: ElementRef,
    public audio: AudioPlayerService
  ) {}
  ngOnDestroy(): void {
    const levelSelectElement =
      this.elRef.nativeElement.querySelector("#button_plakboek");
    if (levelSelectElement) {
      levelSelectElement.removeEventListener(
        "click",
        this.showLevelSelector.bind(this)
      );
    }
  }

  ngOnInit() {
    if (this.version === "broedels") {
      const levelSelectElement =
        this.elRef.nativeElement.querySelector("#button_plakboek");
      if (levelSelectElement) {
        levelSelectElement.addEventListener(
          "click",
          this.showLevelSelector.bind(this)
        );
      }

      //
      this.hideElements.forEach((elementName) => {
        const hideElement = this.elRef.nativeElement.querySelector(
          "#" + elementName
        );
        if (hideElement) {
          hideElement.style.display = "none";
        }
      });

      // set all buttons to inactive
      this.states.forEach((state) => {
        this.levels.forEach((levelname) => {
          const hideElement = this.elRef.nativeElement.querySelector(
            "#" + levelname + "_" + state
          );
          if (hideElement) {
            hideElement.style.display = "none";
          }

        });
      });
      for(let levelNr = 1; levelNr <= 8; levelNr ++) {
          const activeButton = this.elRef.nativeElement.querySelector( '#lvl' + levelNr + "_active");
          const doneButton = this.elRef.nativeElement.querySelector( '#lvl' + levelNr + "_done");
          if (!activeButton) {
            console.log('#lvl' + levelNr + "_active not found" )
          }
          if (!doneButton) {
            console.log('#lvl' + levelNr + "_done not found" )
          }
          activeButton.addEventListener("click", () => {
            this.onLevelClick.emit(levelNr);
          });
          doneButton.addEventListener("click", () => {
            this.onLevelClick.emit(levelNr);
          });
      }
      const startButton = this.elRef.nativeElement.querySelector("#lvl0_active");

      if (startButton) {
        startButton.addEventListener("click", () => {
          this.onLevelClick.emit(0);
        });
      }
      const startButtonDone =
        this.elRef.nativeElement.querySelector("#lvl0_done");
      if (startButtonDone) {
        startButtonDone.addEventListener("click", () => {
          this.onLevelClick.emit(0);
        });
      }
    }
  }
  showLevelSelector(e: Event) {
    this.onLevelSelectClick.emit();
  }

  ngAfterViewInit() {
    // log('load roadmap with active level', this.gameService.getActiveLevel())
    let activeLevels = this.gameService.getActiveLevels();
    if (this.version === "jijenik") {
      for (let i of activeLevels) {
        this.elRef.nativeElement
          .querySelector("#level_" + i)
          .classList.add("completed");
      }
    } else if (this.version === "broedels") {
      activeLevels.forEach((levelNumber, index) => {
        const inactiveElement = this.elRef.nativeElement.querySelector(
          "#lvl" + levelNumber + "_inactive"
        );
        const completedElement = this.elRef.nativeElement.querySelector(
          "#lvl" + levelNumber + "_done"
        );
        const activeElement = this.elRef.nativeElement.querySelector(
          "#lvl" + levelNumber + "_active"
        );

        if (activeElement) {
          activeElement.classList.add("button_active");
        }
        if (inactiveElement) {
          inactiveElement.style.display = "none";
          inactiveElement.classList.add("button_inactive");
        }
        if (completedElement) {
          completedElement.style.display = "block";
          completedElement.classList.add("button_completed");
        }
      });

      const activeLevel = this.gameService.getActiveLevel();
      const levelProgress = this.gameService.getLevelProgress(activeLevel);
      const openGames = levelProgress.filter((lp) => lp.completed === false);
      if (activeLevel === 8 && openGames.length === 0) {
      } else {
        const inactiveElement = this.elRef.nativeElement.querySelector(
          "#lvl" + activeLevel + "_inactive"
        );
        const activeElement = this.elRef.nativeElement.querySelector(
          "#lvl" + activeLevel + "_active"
        );
        const completedElement = this.elRef.nativeElement.querySelector(
          "#lvl" + activeLevel + "_done"
        );
        inactiveElement.style.display = "none";
        activeElement.style.display = "block";
        completedElement.style.display = "none";
      }
    }
  }

  selectLevel(event: Event) {
    let levelId = (event.target as HTMLElement)
      .closest(".level")
      ?.getAttribute("x-data");
    this.onLevelClick.emit(levelId);
  }
}
